import React from 'react'
import DashboardLayout from '../../components/Admin/DashboardLayout'
import { MDBContainer, MDBBtn, MDBIcon, MDBRow, MDBCol } from 'mdb-react-ui-kit'
import AgentContractManager from './../../components/contracting/AgentContractManager/AgentContractManager.component'
import CarrierContactsModal from './../../components/modals/CarrierContactsModal/CarrierContactsModal.component'
import UplineContactsModal from './../../components/modals/UplineContactsModal/UplineContactsModal.component'
import CarrierCommisionModal from './../../components/modals/CarrierCommisionModal/CarrierCommisionModal.component'
import UserProfileService from './../../shared/services/UserProfile.service'
import { isWhiteLabel } from './../../shared/utilities/whiteLabel.function'
import AgentNotes from '../../components/agents/AgentNotes/AgentNotes.component'
import CommissionLevelSerivce from './../../shared/services/CommissionLevel.service'
import ContentModal from './../../components/modals/ContentModal/ContentModal.component'
import { ContentHtml } from './../../components/content'
import MediaUploaderModal from '../../components/modals/MediaUploaderModal'
import UpdateVoidedCheckModal from '../../components/modals/UpdateVoidedCheckModal'

import './AgentContracting.scss'

const fetchCommissionData = async () => {
  return new Promise(async (resolve, reject) => {
    let cl
    try {
      cl = await CommissionLevelSerivce.get(UserProfileService.get('commission_id'))
      resolve(cl && cl?.com_url ? cl.com_url : '')
    } catch (ex) {
      console.error('Error: Failed to fetch commissions data.', ex)
      resolve('')
    }
  })
}

class AgentContractingPage extends React.Component {
  state = {
    comm_level: null,
    e_agent_center: false,
    is_FFM_Cert_uploaded: false,
  }

  _goTo = (event, link, queryParams) => {
    event.preventDefault()

    if (typeof this.props?.history?.push === 'function') {
      const url = new URL(link, window.location.origin)

      // Add query parameters if provided
      if (queryParams) {
        Object.keys(queryParams).forEach(key => {
          url.searchParams.append(key, queryParams[key])
        })
      }

      this.props.history.push(url.pathname + url.search, {
        from: '/agent-contracting',
      })
    } else {
      window.location = link
    }

    return false
  }

  _uploadFFMDocument = () => {
    MediaUploaderModal.open({
      uploadType: 'ffm_document',
      modalContentTop: (
        <div className='text--center fw--500'>
          <h6 className='fw--500'>Upload your FFM Document</h6>
        </div>
      ),
      validationRules: {
        contentType: ['application/pdf'],
      },
      preventAutoClose: true,
      onSuccess: () => {
        console.log('media uploader success')
      },
    })
      .then()
      .catch(err => {
        if (err) console.log('Failed to complete uploading FFM documents.', err)
      })
  }

  _updateVoidedCheck = () => {
    UpdateVoidedCheckModal.open({
      preventAutoClose: true,
      onSuccess: () => {
        console.log('update voided check success')
        this.setState({ is_FFM_Cert_uploaded: true })
      },
    })
      .then()
      .catch(err => {
        if (err) console.log('Failed to complete uploading FFM documents.', err)
      })
  }

  _toggleEagentCenterModal = () =>
    this.setState(prevState => ({
      ...prevState,
      e_agent_center: !this.state.e_agent_center,
    }))

  _renderStatesAvailBtn = () => {
    if (parseInt(UserProfileService.getCurrentUserTypeId()) !== 111)
      return (
        <MDBBtn
          type='button'
          color='indigo'
          className='btn-block mb-1'
          href='https://www.ahcpsales.com/state-carrier-map/'
          target='_blank'
        >
          <MDBIcon icon='map-signs' className='me-1' /> States Availability
        </MDBBtn>
      )
    return <></>
  }

  _renderCommSchedBtn = () => {
    if (
      this.state.comm_level &&
      UserProfileService.getUserDetails()?.com_code &&
      isNaN(UserProfileService.getUserDetails()?.com_code) &&
      parseInt(UserProfileService.getUserDetails()?.com_code) !== 0
    )
      return (
        <MDBBtn
          type='button'
          tag='a'
          color='indigo'
          className='btn-block mb-1'
          target='_blank'
          href={this.state.comm_level}
        >
          <MDBIcon icon='calendar-alt' className='me-1' /> Commission Schedule
        </MDBBtn>
      )
  }

  _renderCarrierContact = () => <CarrierContactsModal />

  _renderNotes = () => {
    return (
      <>
        <AgentNotes></AgentNotes>
      </>
    )
  }

  _renderUplineContactBtn = () => <UplineContactsModal />

  _renderCarrierCommConfBtn = () => {
    if (UserProfileService.isA(['system-admin', 'internal-admin', 'internal-staff'], true)) {
      return <CarrierCommisionModal />
    }
  }

  _renderCommStmtBtn = () => {
    if (
      this.state.comm_level &&
      UserProfileService.getUserDetails()?.com_code &&
      isNaN(UserProfileService.getUserDetails()?.com_code) &&
      parseInt(UserProfileService.getUserDetails()?.com_code) !== 0
    )
      return (
        <MDBBtn
          type='button'
          color='indigo'
          className='btn-block mb-1'
          target='_blank'
          onClick={() => this._toggleEagentCenterModal()}
        >
          <MDBIcon icon='calendar-alt' className='me-1' /> eAgent Center Commissions
        </MDBBtn>
      )
  }

  _updateAgentW9 = () => {
    MediaUploaderModal.open({
      uploadType: 'wallet_w9',
      modalContentTop: (
        <div>
          <div className='text--center fw--500'>
            <h6 className='fw--500'>Upload your most recent W9</h6>
          </div>
          <div>
            <small>
              <strong>
                * {isWhiteLabel() ? 'We do' : 'USABG does'} not send your W9 to carriers automatically. It is your
                responsibility to update & notify carriers upon W9 changes.
              </strong>
            </small>
          </div>
        </div>
      ),
      validationRules: {
        contentType: ['application/pdf'],
      },
    })
      .then()
      .catch(err => {
        if (err) console.log('Failed to complete uploading agent wallet documents.', err)
      })
  }

  _renderSupportingLinks = () => {
    return (
      <ul className='support-link-list'>
        <li>
          <div>
            <a href='/' onClick={event => this._goTo(event, '/eo-policy')}>
              View Agent E&O Policy
            </a>
          </div>
        </li>
        <li>
          <div>
            <a href='/' onClick={event => this._goTo(event, '/state-licenses')}>
              View Agent State Licenses
            </a>
          </div>
        </li>
        <li onClick={event => this._uploadFFMDocument()}>
          <div>
            Upload FFM Certification&nbsp;
            {this.state.is_FFM_Cert_uploaded ? <MDBIcon far icon='check-circle' /> : <></>}
          </div>
        </li>
        {isWhiteLabel() ? (
          <></>
        ) : (
          <li onClick={event => this._goTo(event, '/agent-resources', { id: '872' })}>
            <div>View State License Info & How-To’s</div>
          </li>
        )}
        <li onClick={event => this._updateVoidedCheck()}>
          <div>Update Voided Check</div>
        </li>
        <li onClick={event => this._updateAgentW9()}>
          <div>Update Agent W9</div>
        </li>
      </ul>
    )
  }

  componentDidMount() {
    Promise.all([
      new Promise((resolve, reject) =>
        fetchCommissionData().then(url => resolve({ comm_level: url !== this.state.comm_level ? url : null }))
      ),
    ]).then(responses => {
      let stateUpd = {}
      responses
        .filter(r => !!r && typeof r === 'object')
        .forEach(response => (stateUpd[Object.keys(response).shift()] = Object.values(response).shift()))
      if (Object.keys(stateUpd).length > 0) this.setState(prevState => ({ ...prevState, ...stateUpd }))
    })
  }

  render() {
    return (
      <React.Fragment>
        <DashboardLayout>
          <main id='AgentContractingPage' className='mainSection'>
            <MDBContainer fluid className='mt-5'>
              <h2>Contracting</h2>
              <hr />
              <MDBRow>
                <MDBCol size='12' md='6'>
                  {this._renderStatesAvailBtn()}
                  {isWhiteLabel() ? <></> : this._renderCommSchedBtn()}
                  {this._renderCarrierContact()}
                  {this._renderUplineContactBtn()}
                  {this._renderCarrierCommConfBtn()}
                  {isWhiteLabel() ? <></> : this._renderCommStmtBtn()}
                  {this._renderSupportingLinks()}
                  <ContentHtml contentSlug='contracting-page-howto' />
                </MDBCol>
                <MDBCol size='12' md='6'>
                  {this._renderNotes()}
                </MDBCol>
              </MDBRow>
              <br />
              <div
                className='mb-5'
                style={{
                  backgroundColor: '#FFF',
                  border: 'thin solid white',
                  borderRadius: '0.3rem',
                }}
              >
                <AgentContractManager />
              </div>
            </MDBContainer>
            <ContentModal
              isOpen={!!this.state.e_agent_center}
              contentSlug={'eagent-center-comms'}
              onClose={() => this._toggleEagentCenterModal()}
              wrapperClass='eagent-content-modal'
            />
          </main>
        </DashboardLayout>
      </React.Fragment>
    )
  }
}

export default AgentContractingPage
